var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuybackGuarantee = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13933_9825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.03 17.21V11.93C33.03 10.31 31.72 9 30.1 9H22.75V21.82L18.22 19.05C18.1 18.97 17.93 18.97 17.8 19.05L13.27 21.82V9H5.93C4.31 9 3 10.31 3 11.93V36.1C3 37.72 4.31 39.03 5.93 39.03H30.1C30.41 39.03 30.71 38.97 30.99 38.88C26.71 37.78 23.43 34.17 22.82 29.71C22.75 29.22 22.71 28.72 22.71 28.21C22.71 26.02 23.36 23.97 24.47 22.25C26.31 19.39 29.44 17.44 33.03 17.21Z",
    fill: "#866EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72 30.11C35.72 29.79 35.58 29.52 35.29 29.32C35 29.12 34.55 28.98 33.93 28.91L33.23 28.85C33.16 28.85 33.1 28.83 33.04 28.82V31.24C33.26 31.29 33.5 31.32 33.78 31.32C34.4 31.32 34.88 31.21 35.22 30.99C35.55 30.77 35.72 30.48 35.72 30.11Z",
    fill: "url(#paint0_linear_13933_9825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.74 17.17C33.5 17.17 33.27 17.19 33.03 17.21V21.62H34.55V22.25V23.03C34.94 23.09 35.29 23.18 35.6 23.32C36.14 23.57 36.55 23.93 36.83 24.39C37.11 24.86 37.25 25.43 37.25 26.1H35.23C35.23 25.83 35.17 25.6 35.04 25.39C34.91 25.18 34.74 25.02 34.5 24.89C34.26 24.76 33.96 24.7 33.59 24.7C33.39 24.7 33.21 24.73 33.04 24.76C32.94 24.78 32.85 24.8 32.76 24.83C32.53 24.92 32.36 25.05 32.24 25.22C32.12 25.39 32.06 25.59 32.06 25.82C32.06 26.1 32.17 26.36 32.38 26.58C32.53 26.74 32.76 26.84 33.04 26.91C33.16 26.94 33.28 26.98 33.43 27L34.13 27.06C35.23 27.15 36.11 27.45 36.77 27.96C37.43 28.47 37.76 29.18 37.76 30.09C37.76 30.72 37.6 31.26 37.29 31.7C36.98 32.14 36.53 32.48 35.93 32.71C35.55 32.86 35.09 32.94 34.6 32.99V34.77H33.03V36.08C33.03 37.15 32.45 38.08 31.6 38.59C31.51 38.64 31.43 38.69 31.33 38.73C31.22 38.78 31.11 38.82 31 38.85C31.88 39.08 32.79 39.21 33.74 39.21C39.82 39.21 44.77 34.26 44.77 28.18C44.77 22.1 39.82 17.15 33.74 17.15V17.17Z",
    fill: "url(#paint1_linear_13933_9825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.47 22.25C23.36 23.97 22.71 26.01 22.71 28.21C22.71 28.72 22.76 29.22 22.82 29.71C23.43 34.17 26.71 37.78 30.99 38.88C31.1 38.84 31.22 38.81 31.32 38.76C31.41 38.72 31.5 38.67 31.59 38.62C32.45 38.11 33.02 37.18 33.02 36.11V34.8H32.79V33.01C32.31 32.95 31.89 32.84 31.52 32.68C30.92 32.42 30.47 32.05 30.17 31.56C29.87 31.07 29.72 30.51 29.72 29.86H31.74C31.74 30.12 31.81 30.36 31.95 30.58C32.09 30.8 32.31 30.98 32.61 31.12C32.73 31.17 32.88 31.21 33.02 31.24V28.82C32.13 28.71 31.41 28.43 30.87 27.96C30.29 27.46 30 26.75 30 25.83C30 25.2 30.14 24.67 30.43 24.24C30.71 23.81 31.12 23.49 31.66 23.28C31.98 23.15 32.34 23.07 32.73 23.02V21.62H33.02V17.21C29.43 17.44 26.3 19.39 24.46 22.25H24.47Z",
    fill: "url(#paint2_linear_13933_9825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72 30.11C35.72 29.79 35.58 29.52 35.29 29.32C35 29.12 34.55 28.98 33.93 28.91L33.23 28.85C33.16 28.85 33.1 28.83 33.04 28.82V31.24C33.26 31.29 33.5 31.32 33.78 31.32C34.4 31.32 34.88 31.21 35.22 30.99C35.55 30.77 35.72 30.48 35.72 30.11Z",
    fill: "#5EE1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.74 17.17C33.5 17.17 33.27 17.19 33.03 17.21V21.62H34.55V22.25V23.03C34.94 23.09 35.29 23.18 35.6 23.32C36.14 23.57 36.55 23.93 36.83 24.39C37.11 24.86 37.25 25.43 37.25 26.1H35.23C35.23 25.83 35.17 25.6 35.04 25.39C34.91 25.18 34.74 25.02 34.5 24.89C34.26 24.76 33.96 24.7 33.59 24.7C33.39 24.7 33.21 24.73 33.04 24.76C32.94 24.78 32.85 24.8 32.76 24.83C32.53 24.92 32.36 25.05 32.24 25.22C32.12 25.39 32.06 25.59 32.06 25.82C32.06 26.1 32.17 26.36 32.38 26.58C32.53 26.74 32.76 26.84 33.04 26.91C33.16 26.94 33.28 26.98 33.43 27L34.13 27.06C35.23 27.15 36.11 27.45 36.77 27.96C37.43 28.47 37.76 29.18 37.76 30.09C37.76 30.72 37.6 31.26 37.29 31.7C36.98 32.14 36.53 32.48 35.93 32.71C35.55 32.86 35.09 32.94 34.6 32.99V34.77H33.03V36.08C33.03 37.15 32.45 38.08 31.6 38.59C31.51 38.64 31.43 38.69 31.33 38.73C31.22 38.78 31.11 38.82 31 38.85C31.88 39.08 32.79 39.21 33.74 39.21C39.82 39.21 44.77 34.26 44.77 28.18C44.77 22.1 39.82 17.15 33.74 17.15V17.17Z",
    fill: "#5EE1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.47 22.25C23.36 23.97 22.71 26.01 22.71 28.21C22.71 28.72 22.76 29.22 22.82 29.71C23.43 34.17 26.71 37.78 30.99 38.88C31.1 38.84 31.22 38.81 31.32 38.76C31.41 38.72 31.5 38.67 31.59 38.62C32.45 38.11 33.02 37.18 33.02 36.11V34.8H32.79V33.01C32.31 32.95 31.89 32.84 31.52 32.68C30.92 32.42 30.47 32.05 30.17 31.56C29.87 31.07 29.72 30.51 29.72 29.86H31.74C31.74 30.12 31.81 30.36 31.95 30.58C32.09 30.8 32.31 30.98 32.61 31.12C32.73 31.17 32.88 31.21 33.02 31.24V28.82C32.13 28.71 31.41 28.43 30.87 27.96C30.29 27.46 30 26.75 30 25.83C30 25.2 30.14 24.67 30.43 24.24C30.71 23.81 31.12 23.49 31.66 23.28C31.98 23.15 32.34 23.07 32.73 23.02V21.62H33.02V17.21C29.43 17.44 26.3 19.39 24.46 22.25H24.47Z",
    fill: "url(#paint3_linear_13933_9825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.27 21.82L17.8 19.05C17.92 18.97 18.09 18.97 18.22 19.05L22.75 21.82V9H13.27V21.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.76 27.97C36.1 27.47 35.22 27.17 34.12 27.07L33.42 27.01C33.27 26.99 33.16 26.95 33.03 26.92C32.75 26.85 32.52 26.75 32.37 26.59C32.16 26.37 32.05 26.11 32.05 25.83C32.05 25.6 32.11 25.4 32.23 25.23C32.35 25.06 32.52 24.93 32.75 24.84C32.83 24.81 32.93 24.79 33.03 24.77C33.2 24.73 33.38 24.71 33.58 24.71C33.95 24.71 34.25 24.77 34.49 24.9C34.73 25.03 34.91 25.2 35.03 25.4C35.15 25.6 35.22 25.84 35.22 26.11H37.24C37.24 25.44 37.1 24.87 36.82 24.4C36.54 23.93 36.13 23.57 35.59 23.33C35.29 23.19 34.93 23.1 34.54 23.04V22.26V21.62H32.74V23.02C32.35 23.07 31.98 23.15 31.67 23.28C31.14 23.5 30.73 23.82 30.44 24.24C30.15 24.67 30.01 25.2 30.01 25.83C30.01 26.75 30.3 27.46 30.88 27.96C31.42 28.43 32.14 28.71 33.03 28.82C33.1 28.82 33.16 28.84 33.22 28.85L33.92 28.91C34.54 28.97 35 29.11 35.28 29.32C35.56 29.53 35.71 29.79 35.71 30.11C35.71 30.48 35.54 30.77 35.21 30.99C34.87 31.21 34.39 31.32 33.77 31.32C33.49 31.32 33.25 31.29 33.03 31.24C32.88 31.21 32.74 31.17 32.62 31.12C32.32 30.99 32.1 30.81 31.96 30.58C31.82 30.35 31.75 30.11 31.75 29.86H29.73C29.73 30.51 29.88 31.08 30.18 31.56C30.48 32.04 30.93 32.41 31.53 32.68C31.89 32.84 32.32 32.94 32.8 33.01V34.8H34.6V33.02C35.09 32.97 35.55 32.88 35.93 32.74C36.52 32.51 36.97 32.18 37.29 31.73C37.6 31.29 37.76 30.75 37.76 30.12C37.76 29.2 37.43 28.49 36.77 27.99L36.76 27.97Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13933_9825",
    x1: 41.54,
    y1: 36,
    x2: 25.95,
    y2: 20.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5039FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5039FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5039FF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5039FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5039FF",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5039FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5039FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5039FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5039FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5039FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13933_9825",
    x1: 41.54,
    y1: 36,
    x2: 25.95,
    y2: 20.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5039FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5039FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5039FF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5039FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5039FF",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5039FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5039FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5039FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5039FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5039FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13933_9825",
    x1: 41.54,
    y1: 36,
    x2: 25.95,
    y2: 20.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5039FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5039FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5039FF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5039FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5039FF",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5039FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5039FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5039FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5039FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5039FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13933_9825",
    x1: 25.58,
    y1: 20.19,
    x2: 35.05,
    y2: 36.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D66FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3F66FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4967FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#5969FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6F6BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756CFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13933_9825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.77,
    height: 30.24,
    fill: "white",
    transform: "translate(3 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuybackGuarantee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/buyback_guarantee.0b282be3f7796a941404190ec10571c7.svg";